require('@babel/polyfill');
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');
var tagManager = require('int_googletags/tagManager');

$(document).ready(function () {
    // init specific global components.
    if (window.pageContext && window.pageContext.ns) {
        tagManager.init(window.pageContext.ns);
    }
    processInclude(require('./components/quantitySelector'));
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/emailSignup'));
    processInclude(require('./components/backtotop'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/carousels'));
    processInclude(require('lyonscg/components/tooltips'));
    processInclude(require('./components/einsteinObserver'));
    processInclude(require('plugin_blog/components/carousels'));
    processInclude(require('plugin_blog/components/video'));
    processInclude(require('pagedesigner/experience/carousels'));
    processInclude(require('pagedesigner/experience/heros'));
    processInclude(require('pagedesigner/experience/modal'));
    processInclude(require('pagedesigner/experience/tabs'));
    processInclude(require('pagedesigner/experience/pdProductTiles'));
    processInclude(require('pagedesigner/experience/stickyComponents'));
    processInclude(require('./components/ada'));
    processInclude(require('int_ordergroove/cart/cart'));
    processInclude(require('int_ordergroove_custom/optins'));
});

require('lyonscg/thirdParty/bootstrap');
require('./components/spinner');
require('svg4everybody')({
    polyfill: true // needed for IE11 support
});
require('slick-carousel');
require('picturefill');
require('lazysizes');

// Missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
